module.exports = __webpack_public_path__ + "static/csi_dataviz5-7947220d6ab3c5d542132bfe7e0d61b2.png";